import { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { LoaderContext } from "../AuthContext/AuthContext";
import { usePreviousLocation } from "./CustomePreviousLocationHook";
import { t } from "i18next";

const Breadcrumbs = () => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const prevPath = localStorage.getItem("previousPath") || "/";
  useEffect(() => {

    const segments = location.pathname.split("/").filter(Boolean);
    const breadcrumbItems = [{ label: t("Home"), path: "/" }];


    if (segments.includes("puja-details")) {
      let pathLabel = null;
      if (prevPath === "/remedy-puja") {
        pathLabel = "Remedy Pujas";
      } else if (prevPath === "/homam-puja") {
        pathLabel = "Homam pujas";
      } else if (prevPath === "/daily-pandit-puja") {
        pathLabel = "Daily Pandit Pujas";
      } else if (prevPath === "/remedy-subscription-puja") { pathLabel = "Subscription Remedy Pujas"; }
      else if (prevPath === "/homam-subscription-puja") { pathLabel = "Subscription Homam Pujas"; }
      else if (prevPath === "/pandit-puja") { pathLabel = "Pandit Pujas"; }
      breadcrumbItems.push({
        label: pathLabel,
        path: prevPath,
      });

      // breadcrumbItems.push({
      //   label: "Puja Details",
      //   path: t(location.pathname), // full path
      // });
    } if (segments.includes("product-details")) {
      let pathLabel = null;
      if (prevPath === "/my-store") {
        pathLabel = t("E-Store");
      }
      breadcrumbItems.push({
        label: pathLabel,
        path: t(prevPath),
      });

      breadcrumbItems.push({
        label: "Product Details",
        path: t(location.pathname), // full path
      });
    } else if (segments.length > 0) {
      // For other pages, just show Home > Current Page
      const currentPage = segments[segments.length - 1]
        .replace(/-/g, " ") // replace dashes with spaces
        .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letter

      breadcrumbItems.push({
        label: currentPage,
        path: t(location.pathname),
      });
    }

    setBreadcrumbs(breadcrumbItems);
  }, [location, prevPath]);


  return (
    <nav aria-label="breadcrumb" className="mb-2">
      <ol className="breadcrumb mb-0">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li
              key={index}
              className={`breadcrumb-item ${isLast ? "active" : ""}`}
              aria-current={isLast ? "page" : undefined}
            >
              {isLast ? (
                <span style={{ color: "white", fontWeight: "600" }}>
                  {t(crumb.label)}
                </span>
              ) : (
                <Link to={crumb.path} className="text-decoration-none" style={{ color: "white" }}>
                  {t(crumb.label)}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
